(function() {
  console.log("Redirection script loaded");
  // Make sure Shopify Markets country is available
  const userCountry = window.Shopify?.country;
  console.log(userCountry);

  // Only redirect US customers
  if (userCountry !== "BM") return;

  const path = window.location.pathname;

  // Only redirect URLs that contain /tools/recurring
  if (!path.startsWith("/tools/recurring")) return;

  // Replace only the domain, keep full path + query string
  const newUrl = window.location.href.replace("https://movewithus.com", "https://movewithus.com.au");

  // Perform the redirect
  window.location.replace(newUrl);
})();
